import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'
import { arrayOfOptions } from '@/utils/zod'

type Params = {
  semester?: string
  groupId?: string
  classId?: string
  studentIds?: string[]
}

const useAddedByOptions = (params: Params) =>
  useQuery({
    queryKey: ['panelCommentsOptionsAddedByList', params],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelCommentsOptionsAddedByList({
        semester_id: params.semester,
        group_id: params.groupId,
        student_id: params.studentIds,
        class_id: params.classId
      })

      return arrayOfOptions.parse(response.results)
    }
  })

export default useAddedByOptions
